var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _g, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeoBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416.855 206.3C462.774 231.283 487.188 266.372 489.616 302.879C492.043 339.385 472.492 377.399 430.286 408.243C388.079 439.088 331.239 456.896 273.455 460.739C215.671 464.582 156.973 454.459 111.053 429.475C65.1343 404.492 40.7206 369.402 38.2926 332.895C35.8646 296.389 55.4164 258.375 97.622 227.531C139.829 196.686 196.669 178.878 254.453 175.035C312.237 171.192 370.935 181.316 416.855 206.3Z",
    stroke: "url(#paint0_linear_713_253)",
    strokeWidth: 0.581485
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M417.571 215.175C463.538 240.184 488.018 275.335 490.453 311.943C492.887 348.551 473.278 386.634 431.028 417.511C388.778 448.387 331.893 466.206 274.075 470.051C216.258 473.897 157.514 463.768 111.547 438.759C65.58 413.749 41.1002 378.599 38.6655 341.991C36.2308 305.383 55.8399 267.3 98.0898 236.423C140.34 205.546 197.225 187.728 255.043 183.883C312.86 180.037 371.604 190.165 417.571 215.175Z",
    stroke: "url(#paint1_linear_713_253)",
    strokeWidth: 0.116297
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M440.591 193.211C493.651 223.413 521.949 265.71 524.871 309.656C527.794 353.601 505.347 399.273 456.754 436.236C408.159 473.2 342.641 494.433 275.991 498.865C209.341 503.298 141.588 490.93 88.526 460.726C35.4659 430.524 7.16857 388.227 4.24583 344.281C1.32311 300.336 23.7698 254.664 72.3629 217.701C120.958 180.736 186.476 159.504 253.126 155.071C319.776 150.639 387.529 163.007 440.591 193.211Z",
    stroke: "url(#paint2_linear_713_253)",
    strokeWidth: 0.581485
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M440.591 193.211C493.651 223.413 521.949 265.71 524.871 309.656C527.794 353.601 505.347 399.273 456.754 436.236C408.159 473.2 342.641 494.433 275.991 498.865C209.341 503.298 141.588 490.93 88.526 460.726C35.4659 430.524 7.16857 388.227 4.24583 344.281C1.32311 300.336 23.7698 254.664 72.3629 217.701C120.958 180.736 186.476 159.504 253.126 155.071C319.776 150.639 387.529 163.007 440.591 193.211Z",
    stroke: "url(#paint3_linear_713_253)",
    strokeOpacity: 0.2,
    strokeWidth: 0.581485
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M441.13 201.472C494.429 235.304 523.057 282.365 526.298 331.089C529.538 379.813 507.395 430.251 459.045 470.843C410.693 511.438 345.3 534.485 278.656 538.917C212.012 543.35 144.143 529.166 90.84 495.332C37.5407 461.5 8.9128 414.438 5.67226 365.715C2.43175 316.991 24.5751 266.553 72.9247 225.96C121.277 185.365 186.67 162.319 253.314 157.886C319.958 153.454 387.827 167.638 441.13 201.472Z",
    stroke: "url(#paint4_linear_713_253)",
    strokeWidth: 0.581485
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 306.718,
    y: 407.388,
    width: 2.44384,
    height: 2.44384,
    transform: "rotate(131.195 306.718 407.388)",
    fill: "#00F0FF",
    fillOpacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 247.675,
    y: 486.438,
    width: 1.00768,
    height: 1.00768,
    transform: "rotate(131.195 247.675 486.438)",
    fill: "#00F0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.32335,
    height: 1.32335,
    transform: "matrix(0.658623 -0.752472 -0.752473 -0.658624 77.1274 382.522)",
    fill: "#00F0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 202.735,
    y: 485.932,
    width: 1.524,
    height: 1.524,
    transform: "rotate(131.195 202.735 485.932)",
    fill: "#00F0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 212.509,
    y: 465.496,
    width: 0.903196,
    height: 0.903196,
    transform: "rotate(131.195 212.509 465.496)",
    fill: "#00F0FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 295.738,
    y: 347.391,
    width: 2.44384,
    height: 2.44384,
    transform: "rotate(131.195 295.738 347.391)",
    fill: "#00F0FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 378.605,
    y: 354.936,
    width: 2.44384,
    height: 2.44384,
    transform: "rotate(131.195 378.605 354.936)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 349.534,
    y: 426.984,
    width: 1.708,
    height: 1.708,
    transform: "rotate(131.195 349.534 426.984)",
    fill: "#3DFFFB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 253.971,
    y: 219.71,
    width: 3.17857,
    height: 3.17857,
    transform: "rotate(131.195 253.971 219.71)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.39378,
    height: 3.39378,
    transform: "matrix(-0.658627 0.752469 -0.752476 -0.65862 104.089 181.369)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 6.85416,
    height: 6.85416,
    transform: "matrix(-0.658622 0.752474 -0.752471 -0.658625 39.0229 221.821)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.18939,
    height: 3.18939,
    transform: "matrix(0.658623 -0.752473 -0.752473 -0.658623 42.5112 347.336)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.39378,
    height: 3.39378,
    transform: "matrix(-0.65862 0.752476 -0.752469 -0.658627 107.152 106.231)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 222.371,
    y: 116.722,
    width: 3.39378,
    height: 3.39378,
    transform: "rotate(131.195 222.371 116.722)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 2.37479,
    height: 2.37478,
    transform: "matrix(-0.658618 0.752477 -0.752468 -0.658629 159.255 172.889)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 169.161,
    y: 143.261,
    width: 4.41946,
    height: 4.41946,
    transform: "rotate(131.195 169.161 143.261)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 2.90527,
    height: 2.90527,
    transform: "matrix(0.597677 0.801737 -0.801758 0.597649 148.665 304.613)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 2.27283,
    height: 2.27283,
    transform: "matrix(0.752468 0.658629 -0.658618 0.752477 170.14 368.829)",
    fill: "#00D1FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 2.7303,
    height: 2.7303,
    transform: "matrix(-0.597663 -0.801748 -0.801748 0.597663 276.51 385.928)",
    fill: "#001AFF",
    fillOpacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 224.45,
    y: 430.585,
    width: 2.90527,
    height: 2.90527,
    transform: "rotate(53.2973 224.45 430.585)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 2.90527,
    height: 2.90527,
    transform: "matrix(0.597677 0.801737 -0.801758 0.597649 86.3364 288.568)",
    fill: "#0066FF",
    fillOpacity: 0.5
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 124.935,
    y: 414.245,
    width: 2.10047,
    height: 2.10047,
    transform: "rotate(41.195 124.935 414.245)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 2.03257,
    height: 2.03257,
    transform: "matrix(0.597683 0.801733 -0.801762 0.597643 151.469 256.926)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 128.453,
    y: 243.32,
    width: 3.78259,
    height: 3.78259,
    transform: "rotate(53.2973 128.453 243.32)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 1.62762,
    height: 1.62762,
    transform: "matrix(-0.658631 0.752466 -0.752479 -0.658616 291.693 392.879)",
    fill: "#00FFF0",
    fillOpacity: 0.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 367.37,
    y: 315.312,
    width: 1.83369,
    height: 1.8337,
    transform: "rotate(131.195 367.37 315.312)",
    fill: "#00FFF0"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 2.02462,
    height: 2.02462,
    transform: "matrix(0.658624 -0.752472 -0.752473 -0.658623 339.925 454.995)",
    fill: "#00FFF0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 290.29,
    y: 453.793,
    width: 2.15437,
    height: 2.15437,
    transform: "rotate(131.195 290.29 453.793)",
    fill: "#00FFF0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 2.15437,
    height: 2.15437,
    transform: "matrix(-0.658618 0.752478 -0.752468 -0.658629 214.305 291.892)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 274.659,
    y: 304.743,
    width: 1.181,
    height: 1.18101,
    transform: "rotate(131.195 274.659 304.743)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 349.279,
    y: 269.447,
    width: 2.15437,
    height: 2.15437,
    transform: "rotate(95.8851 349.279 269.447)",
    fill: "#0500FF",
    fillOpacity: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 337.441,
    y: 322.236,
    width: 1.50414,
    height: 1.50414,
    transform: "rotate(131.195 337.441 322.236)",
    fill: "#00D1FF",
    fillOpacity: 0.6
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 332.797,
    y: 303.741,
    width: 4.05533,
    height: 4.05533,
    transform: "rotate(131.195 332.797 303.741)",
    fill: "#6100FF",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.41,
    y: 487.758,
    width: 1.62762,
    height: 1.62762,
    transform: "rotate(131.195 322.41 487.758)",
    fill: "#00FFF0",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.8337,
    height: 1.83369,
    transform: "matrix(-0.65863 0.752467 -0.752478 -0.658617 398.087 410.19)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.02462,
    height: 2.02462,
    transform: "matrix(0.658623 -0.752473 -0.752472 -0.658624 370.643 549.872)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.15437,
    height: 2.15437,
    transform: "matrix(-0.658617 0.752478 -0.752467 -0.658629 321.008 548.672)",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.022,
    y: 386.77,
    width: 2.15437,
    height: 2.15437,
    transform: "rotate(131.195 245.022 386.77)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.376,
    y: 399.621,
    width: 1.18101,
    height: 1.181,
    transform: "rotate(131.195 305.376 399.621)",
    fill: "#00FFF0",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.995,
    y: 364.324,
    width: 2.15437,
    height: 2.15437,
    transform: "rotate(95.8851 379.995 364.324)",
    fill: "#0500FF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.159,
    y: 417.113,
    width: 1.50414,
    height: 1.50414,
    transform: "rotate(131.195 368.159 417.113)",
    fill: "#00D1FF",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.05533,
    height: 4.05533,
    transform: "matrix(-0.65862 0.752475 -0.75247 -0.658627 363.516 398.617)",
    fill: "#6100FF",
    fillOpacity: 0.5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M335.218 531.475L332.492 542.948L324.025 534.739L326.751 523.266L335.218 531.475Z",
    fill: "url(#paint5_linear_713_253)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M324.027 534.739L332.494 542.947L349.348 527.354L324.027 534.739Z",
    fill: "url(#paint6_linear_713_253)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M324.027 534.736L326.739 523.261L349.348 527.352L324.027 534.736Z",
    fill: "url(#paint7_linear_713_253)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7212 406.822L68.7498 410.361L70.2951 400.842L79.2665 397.303L77.7212 406.822Z",
    fill: "url(#paint8_linear_713_253)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2937 400.84L68.7481 410.361L87.0962 414.373L70.2937 400.84Z",
    fill: "url(#paint9_linear_713_253)",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2936 400.841L79.2618 397.291L87.0962 414.374L70.2936 400.841Z",
    fill: "url(#paint10_linear_713_253)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.577 483.003L127.749 493.695L124.607 478.064L136.435 467.372L139.577 483.003Z",
    fill: "url(#paint11_linear_713_253)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.61 478.063L127.752 493.695L158.475 489.239L124.61 478.063Z",
    fill: "url(#paint12_linear_713_253)",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.61 478.063L136.424 467.358L158.475 489.239L124.61 478.063Z",
    fill: "url(#paint13_linear_713_253)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M339.278 453.62L342.011 450.077L341.069 445.159L337.387 443.484L336.321 448.686L339.278 453.62Z",
    fill: "url(#paint14_linear_713_253)",
    fillOpacity: 0.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M357.509 445.078L345.375 441.757L340.26 439.632L357.509 445.078Z",
    fill: "url(#paint15_linear_713_253)",
    fillOpacity: 0.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M357.51 445.077L347.154 451.138L343.348 455.989L357.51 445.077Z",
    fill: "url(#paint16_linear_713_253)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M343.349 455.989L347.155 451.135L342.012 450.077L339.278 453.621L343.349 455.989Z",
    fill: "url(#paint17_linear_713_253)",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M345.375 441.758L347.154 451.136L342.01 450.078L341.068 445.161L345.375 441.758Z",
    fill: "url(#paint18_linear_713_253)",
    fillOpacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M345.377 441.757L340.26 439.632L337.386 443.484L341.069 445.16L345.377 441.757Z",
    fill: "url(#paint19_linear_713_253)",
    fillOpacity: 0.8
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M357.509 445.078L338.583 448.039L340.26 439.632L357.509 445.078Z",
    fill: "url(#paint20_linear_713_253)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.509 445.078L338.584 448.039L343.347 455.99L357.509 445.078Z",
    fill: "url(#paint21_linear_713_253)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340.26 439.631L338.583 448.039L336.32 448.687L337.388 443.483L340.26 439.631Z",
    fill: "url(#paint22_linear_713_253)",
    fillOpacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M343.35 455.989L338.585 448.039L336.32 448.686L339.28 453.622L343.35 455.989Z",
    fill: "url(#paint23_linear_713_253)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_713_253",
    x1: 278.05,
    y1: 529.832,
    x2: 262.727,
    y2: 299.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_713_253",
    x1: 274.907,
    y1: 482.549,
    x2: 255.039,
    y2: 183.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_713_253",
    x1: 282.199,
    y1: 592.209,
    x2: 261.196,
    y2: 276.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_713_253",
    x1: 132.935,
    y1: 478.175,
    x2: 167.718,
    y2: 398.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF48D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234164,
    stopColor: "white",
    stopOpacity: 0.765836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF48D7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_713_253",
    x1: 279.777,
    y1: 555.79,
    x2: 264.571,
    y2: 327.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FBCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FBCFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_713_253",
    x1: 335.977,
    y1: 536.592,
    x2: 323.266,
    y2: 529.622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_713_253",
    x1: 329.274,
    y1: 543.152,
    x2: 349.374,
    y2: 527.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_713_253",
    x1: 349.314,
    y1: 527.235,
    x2: 327.063,
    y2: 524.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_713_253",
    x1: 74.6437,
    y1: 409.726,
    x2: 73.3726,
    y2: 397.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_713_253",
    x1: 67.1037,
    y1: 408.296,
    x2: 87.0482,
    y2: 414.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_713_253",
    x1: 87.1584,
    y1: 414.297,
    x2: 78.3592,
    y2: 398.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_713_253",
    x1: 136.501,
    y1: 489.286,
    x2: 127.682,
    y2: 471.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6083FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1E5E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_713_253",
    x1: 124.007,
    y1: 491.456,
    x2: 158.435,
    y2: 489.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_713_253",
    x1: 158.526,
    y1: 489.084,
    x2: 135.581,
    y2: 469.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_713_253",
    x1: 342.634,
    y1: 452.11,
    x2: 336.123,
    y2: 447.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6587FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E0FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_713_253",
    x1: 343.224,
    y1: 447.628,
    x2: 343.409,
    y2: 435.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_713_253",
    x1: 351.526,
    y1: 455.195,
    x2: 351.459,
    y2: 444.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_713_253",
    x1: 340.554,
    y1: 456.488,
    x2: 341.322,
    y2: 449.861,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_713_253",
    x1: 344.622,
    y1: 451.588,
    x2: 349.897,
    y2: 447.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_713_253",
    x1: 338.159,
    y1: 443.798,
    x2: 338.425,
    y2: 438.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_713_253",
    x1: 355.953,
    y1: 436.791,
    x2: 345.146,
    y2: 449.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3DDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427083,
    stopColor: "#9D50FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977116,
    stopColor: "#3DDCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_713_253",
    x1: 337.15,
    y1: 454.496,
    x2: 349.867,
    y2: 435.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.170794,
    stopColor: "#3D3BA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537799,
    stopColor: "#FF7BE2",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_713_253",
    x1: 335.686,
    y1: 448.556,
    x2: 339.237,
    y2: 439.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.135417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#89F8FF",
    stopOpacity: 0.934673
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#71F6FF",
    stopOpacity: 0.921354
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A72FF",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_713_253",
    x1: 342.589,
    y1: 451.724,
    x2: 335.995,
    y2: 452.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E5ABE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5ABE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeoBackground);
export default __webpack_public_path__ + "static/media/ceo-background.1f126a49771baa7f2d4abb2fe0e6a463.svg";
export { ForwardRef as ReactComponent };